import { ref, Ref } from 'vue';
import { ToggleButtonData } from 'components/global-common/ToggleButtonData.model';
import { useLayoutStore } from 'stores/layout-store';

const MAX_TOGGLE = 3;

const SEX_OPTIONS = [
  {
    value: '1',
    label: 'Male'
  },
  {
    value: '2',
    label: 'Female'
  },
  {
    value: '3',
    label: 'Unknown'
  }];

const TOGGLE_BUTTON_LIST: Ref<Array<ToggleButtonData>> = ref([
  {
    id: 1,
    label: 'Codes',
    pressed: useLayoutStore().isCodesSelected,
    disabled: false,
  },
  {
    id: 2,
    label: 'Search',
    pressed: useLayoutStore().isSearchSelected,
    disabled: false,
  },
  {
    id: 3,
    label: 'References',
    pressed: useLayoutStore().isReferencesSelected,
    disabled: false,
  },
  {
    id: 4,
    label: 'Resources',
    pressed: useLayoutStore().isResourcesSelected,
    disabled: false,
  },
]);

export { MAX_TOGGLE, SEX_OPTIONS, TOGGLE_BUTTON_LIST }